import React, { useMemo, } from 'react';
import { useIntl } from 'umi';
import { Col, Row } from 'tea-component';
import useCommunityVideoTimeLineData from './useCommunityVideoTimeLineData';
import OpinionsVideoChart from './OpinionsVideoChart';
import OpinionsCard from '../OpinionsCard';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import { formatDateFunc } from '@op/utils/time';
import { reviewsFormat } from '@op/utils/value';
import { getShowCount } from '@op/utils';
import '@/pages/opinion/assets/scss/pages/community/video.scss';
import './index.scss';
function OpinionsVideo(props: any) {
  const { gameInfo, filter, filterCond, extraParams, formatRule = 'intBmk00', id, refArray, index, style } = props;

  const keepParams = useMemo(() => {
    if (!filter?.date_type || !filterCond) return {};
    const { entity_image, isConfirm, ...restFilter } = filter || {};
    return { 
      ...(restFilter || {}),
      social_media_by_account: filterCond?.social_media_by_account || undefined,
      social_media_by_keyword: undefined,
      ...extraParams 
    };
  }, [extraParams, filter, filterCond]);

  // 默认选中official-accounts
  const officialKeepParams = useMemo(() => {
    if (!filter?.date_type || !filterCond) return {};
    const { entity_image, isConfirm, ...restFilter } = filter || {};
    const social_media_by_account = filterCond?.monitor_by_account_category?.monitory?.["official-accounts"]?.map((v: { account: any; }) => v?.account?.toLowerCase()) || [];
    return { ...(restFilter || {}), social_media_by_account, social_media_by_keyword: [], ...extraParams };
  }, [extraParams, filter, filterCond]);

  const { data: countsData, loading: countsLoading } = useCommunityVideoTimeLineData({ type: "counts", keepParams });
  const { data: viewsData, loading: viewsLoading } = useCommunityVideoTimeLineData({ type: "views", keepParams });
  const { data: engagementsData } = useCommunityVideoTimeLineData({ type: "engagements", keepParams });
  const { data: officialEngagementsData } = useCommunityVideoTimeLineData({ type: "engagements", keepParams: officialKeepParams });

  const { locale } = useIntl();
  const isEn = locale === 'en-US';
  const formatDate = formatDateFunc(keepParams?.date_type);

  const cardList = useMemo(() => [
    { title: isEn ? "Total Views" : "总观看量", value: viewsData?.count, formatRule, data: viewsData },
    { title: isEn ? "Video Counts" : "视频发帖量", value: countsData?.count, formatRule, data: countsData },
    { title: isEn ? "Engagement" : "互动量", value: engagementsData?.count, formatRule, data: engagementsData },
    { title: isEn ? "Official Engagement" : "官号互动量", value: officialEngagementsData?.count, formatRule, data: officialEngagementsData },
  ], [isEn, viewsData, formatRule, countsData, engagementsData, officialEngagementsData]);

  return (
    <div className='dbh-opinions-video' id={id} data-scroll-index={index} ref={refArray?.[index]} style={style} >
      <Row className="dbo-video-card">
        {
          cardList?.map((item: any) => {
            const { title, value, formatRule, data } = item || {};
            return <Col span={6} key={title}>
              <OpinionsCard
                title={title}
                value={value}
                dataValue={
                  typeof data.count !== 'undefined'
                    ? getShowCount(data.count)
                    : '-'
                }
                formatRule={formatRule}
                footer={
                  <div>
                    <span className='dbh-opinions-video-footer-text'>DoD</span>
                    <RingRatioBubble
                      title={title}
                      newTime={data?.time_line}
                      oldTime={data?.ratio_time_line}
                      oldValue={data?.ratio}
                      newValue={data?.count}
                      formateValue={reviewsFormat}
                      formateDate={(value) => formatDate(value)}
                    >
                      <PercentageItem percentage={data?.ratio_val}></PercentageItem>
                    </RingRatioBubble>
                  </div>
                }
              />
            </Col>;
          })
        }
      </Row>
      <Row className="dbo-video-card">
        <Col span={12}>
          <OpinionsVideoChart
            data={countsData}
            loading={countsLoading}
            gameInfo={gameInfo}
            type="counts"
            keepParams={keepParams}
          />
        </Col>
        <Col span={12}>
          <OpinionsVideoChart
            data={viewsData}
            loading={viewsLoading}
            gameInfo={gameInfo}
            type="views"
            keepParams={keepParams}
          />
        </Col>
      </Row>
    </div>
  );
}

export default OpinionsVideo;
